import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, computed, withDefaults } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { ScopeServiceFragmentFragment } from "@/gql"
import { useNotification } from "@/hooks/useNotification"

export type Service = {
  id: string
  title: string
  description: string
  icon: string
  backgroundColor: string
  iconColor: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceList',
  props: {
    services: null,
    selectedService: null,
    hideSearch: { type: Boolean },
    required: { type: Boolean, default: true }
  },
  emits: [
  "goto-next",
  "goto-prev",
  "update-selected-service",
  "update-service-group",
],
  setup(__props: any, { expose, emit }) {

const props = __props as { services: ScopeServiceFragmentFragment[], selectedService?: ScopeServiceFragmentFragment | null, hideSearch?: boolean, required: boolean }



const cachedGroupedServices = computed(() => {
  if (!props.services) return null
  return Object.groupBy(props.services, (service) => service.serviceGroup.name)
})



const { addError } = useNotification()

const groupedServices = ref(cachedGroupedServices.value)
const selectedService = ref<ScopeServiceFragmentFragment | null>(null)

const selectedServices = ref<ScopeServiceFragmentFragment[] | null>(null)
const selectedServiceGroup = ref<string | null>(null)

const noServiceSelectedError = ref(false)

const onServiceClicked = (service: ScopeServiceFragmentFragment) => {
  selectedService.value = service
  noServiceSelectedError.value = false
  emit("update-selected-service", service)
}

const onServiceGroupClicked = (
  serviceGroup: string,
  services: ScopeServiceFragmentFragment[] | undefined
) => {
  selectedServiceGroup.value = serviceGroup
  emit("update-service-group", serviceGroup)

  if (!services) return
  selectedServices.value = services
}

const gotoNext = () => {
  if (props.required && !selectedService.value?.id) return addError("Please select a service")

  if (selectedServiceGroup.value && !selectedService.value) {
    noServiceSelectedError.value = true
  }

  emit("goto-next")
}

const populateForm = () => {
  if (!props.selectedService) return

  selectedService.value = props.selectedService
  selectedServiceGroup.value = props.selectedService.serviceGroup.name
  selectedServices.value =
    (cachedGroupedServices?.value &&
      cachedGroupedServices.value[props.selectedService.serviceGroup.name]) ||
    []
}

onMounted(() => {
  populateForm()
})

watch(props, () => {
  if (!props.selectedService) selectedService.value = null
  else {
    populateForm()
  }
})

const searchKey = ref("")

watch(searchKey, (searchKey) => {
  if (!props.services.length) return

  if (!searchKey) {
    groupedServices.value = cachedGroupedServices.value
  } else {
    groupedServices.value = searchFn(searchKey)
  }
})

const searchFn = (searchTerm: string): Partial<Record<string, ScopeServiceFragmentFragment[]>> => {
  const source = cachedGroupedServices.value as Record<string, ScopeServiceFragmentFragment[]>
  const searchTermLower = searchTerm.toLowerCase()

  return Object.entries(source).reduce((acc, [key, services]) => {
    const keyLower = key.toLowerCase()

    if (keyLower.includes(searchTermLower)) {
      acc[key] = services
    } else {
      const matchingServices = services?.filter((service) => {
        const combinedText = `${service.name} ${service.description}`.toLowerCase()
        return combinedText.includes(searchTermLower)
      })

      if (matchingServices?.length) {
        acc[key] = matchingServices
      }
    }

    return acc
  }, {} as Partial<Record<string, ScopeServiceFragmentFragment[]>>)
}

expose({
  gotoNext,
})

return { __sfc: true,props, cachedGroupedServices, emit, addError, groupedServices, selectedService, selectedServices, selectedServiceGroup, noServiceSelectedError, onServiceClicked, onServiceGroupClicked, gotoNext, populateForm, searchKey, searchFn, Icon }
}

})